import React, { Component } from 'react'
import Swal from "sweetalert2";
import "../../../css/general-style.css"
import "../../../css/pickingSystem-style.css"
import '../../../css/dashboard.css'
import { AiOutlineComment, AiOutlineSearch } from "react-icons/ai"
import { FiTrash, FiSave } from "react-icons/fi";
import { BsBoxSeam } from "react-icons/bs";
import { getValueCookie } from '../../../services/cookieService'
import { create_Delete_Update_Information, getInformationWithData, saveJsonData, getInformationWithDataV3 } from '../../../services/CABE'
import { DateFormatMAS90, FormatQueryReturnDateForReport, getActualDateUTC, getDateYearMonthDayDash } from '../../../functions/dateFormat';
import LoadingWindow from '../../../components/LoadingWindow';
import FinishedSalesOrderList from './FinishedSalesOrderList';
import { confirmCloseAlert } from '../../../functions/alerts';
import { getPrintHeaderCompany } from '../../../functions/companyInformation';
import { OrderPDF } from '../../../components/OrderPDF';
import { pricesFormat } from '../../../functions/pricesFormat';
import { DecimalPart, getPriceMargin, getPurePriceMargin, MobileDisp, NumberFormat, OrderArray, validateNumbersForQuantitys } from '../../../functions/generalFunctions';
import SearchUPC from '../../../components/SearchUPC';
import Catalogue2 from '../../../components/Catalogue2.0/Catalogue2.0';
import SingleOrderPicking from './SingleOrderPicking'
import { DownloadOrderPDF } from '../../../components/DownloadOrderPDF';
import { buildSalesOrderNo } from '../../../functions/documentPrefix';
import { Menu } from "../../../components/Menu/Menu";



export default class SalesPickingSystem extends Component {

    constructor(props) {
        super(props);
        this.ModalLoading = React.createRef();
    }

    state = {
        disable: false,
        isInputFocused: false,
        ConfirmSave: 0,
        ProductList: [],
        ProductsForAltitude: [],
        Products: [],
        SalesOrder: {
            Customer: {
                AddressLine1: '',
                City: '',
                CustomerName: '',
                CustomerNo: '',
                EmailAddress: '',
                PriceLevel: undefined,
                SalespersonNo: '',
                State: '',
                TelephoneNo: '',
                ZipCode: '',
                uniqueTrack: '',
            },
            NoOrder: '',
            Type: 'S',
            TotalQuantityOrdered: 0,
            TotalCost: 0,
            TotalWeight: 0,
            Date: getDateYearMonthDayDash(),
            Warehouse: '000',
            Packing: null,
            WeightOption: null,
            MAS90Status: 0,
            TotalLines: 0,
            Duplicate: false,
            status: null,
        },
        companyPrintHeader: getPrintHeaderCompany(),
        showModal1: false,
        confirmMargin: false,
        NotZeroUnitPrice: true,
        enableEdit: false,
        isNotNewSO: true,
        newSalesOrder: false,
        currentStep: 1, // Wizard Step
        formData: {}, // Wizard validation 
        disableSelectOrder: false
    }

    setupBeforeUnloadListener = () => {
        if (this.state.Products.length > 0) {
            window.addEventListener("beforeunload", (ev) => {
                ev.preventDefault();
                ev.returnValue = '';
                return this.doSomethingBeforeUnload();
            });
        }
    };

    async getNewCorrelativeSalesOrder() {
        this.clearSalesOrder()
        const data = {
            type: 'SalesOrder',
            idCompany: getValueCookie('CompanyId')
        }
        const result = await getInformationWithDataV3('/sales/get/correlative', data)
        if (result.status.code === 1) {
            const temporal = this.state.SalesOrder
            temporal.NoOrder = buildSalesOrderNo(result.data[0].correlative)
            this.setState({ SalesOrder: temporal })
        }
    }

    valueRadioButton = async e => {
        let stat = e.target.value
        const temporal = this.state.SalesOrder
        temporal.Type = stat
        this.setState({ SalesOrder: temporal })
    }

    calculateTotals() {
        let totalQuantity = 0
        let totalCost = 0
        let totalWeight = 0
        let totalPrice = 0
        const temporal = this.state.Products
        const temporal2 = this.state.SalesOrder

        for (const item of temporal) {

            totalPrice += Number(item.LastTotalUnitCost) * Number(item.quantityOrdered)
            totalQuantity += Number(item.quantityOrdered)
            totalCost += Number(item.totalCost)
            totalWeight += Number(item.quantityOrdered) * Number(item.ShipWeight)
        }

        temporal2.TotalQuantityOrdered = totalQuantity
        temporal2.TotalCost = totalCost
        temporal2.TotalWeight = totalWeight
        temporal2.Customer.uniqueTrack = getPriceMargin(totalCost, totalPrice, temporal2.Customer.PriceLevel)
        this.setState({ SalesOrder: temporal2 })
        this.AutoSave()
    }
    
    async getItemList() {
        const data = {
            idcompany: "3"
        }
        try {
            let response = await getInformationWithData('/Items/get', data);
            console.log(response)
            this.setState({ProductList: response.data})
        } catch (error) {
            console.log(error)
        }
    }
    
    setAltPrice(item){
        let altitudePrice = item.LastTotalUnitCost / 0.95;
        altitudePrice = altitudePrice / (1 - (item.MarkUp / 100));
        return altitudePrice;
    }

    checkMinPrice(temporal, newValue) {
        const productList = this.state.ProductList;
        const originalItem = productList.find(item => item.itemCode === temporal.itemCode);
        const newPrice = Number(newValue.target.value);
        const n1Price = originalItem.UnitPrice

        if(newPrice < n1Price) {
            let altitudePrice = this.setAltPrice(originalItem);

            if(altitudePrice < n1Price) {
                altitudePrice = n1Price;
            }

            const totalCost = temporal.quantityOrdered * altitudePrice;

            this.setState((prevState) => ({
                Products: prevState.Products.map((item) => 
                    item.itemCode === temporal.itemCode
                    ? { ...item, UnitPrice: Number(altitudePrice.toFixed(2)), totalCost: totalCost}
                    : item
                )
            }))
            alert(`The lower price for this product is $${ NumberFormat(pricesFormat(n1Price)) }`)
            return false
        }
        return true
    }

    onTargetChange(e, product) {
        let newPrice = e.target.value;
        this.setState((prevstate) => {
            const updatedProducts = prevstate.Products.map((item) => {
                if(item.itemCode === product.itemCode) {
                    return { ...item, UnitPrice: newPrice };
                }
                return item
            });
            return { Products: updatedProducts }
        })
    }

    onTarget = async (e, item) => {
        const temporal = this.state.Products
        const ident = e.target.id.split('_')
        const index = temporal.indexOf(item)

        if (index !== -1) {
            if (ident[0] === "quantityOrderedSalesOrder") {
                    let quant = Number(e.target.value)

                    if (!validateNumbersForQuantitys(quant)) {
                        let parteDecimal = 1 - DecimalPart(quant)
                        quant += parteDecimal
                        document.getElementById(e.target.id).value = quant
                    }

                    temporal[index].quantityOrdered = Number(quant)
                    temporal[index].totalCost = (Number(quant) * Number(temporal[index].UnitPrice))
                    this.setState({ Products: temporal, ConfirmSave: 0 })
                    this.calculateTotals()
            } else if (ident[0] === "unitPriceSalesOrder") {
                temporal[index].UnitPrice = Number(e.target.value)
                temporal[index].totalCost = (Number(e.target.value) * Number(temporal[index].quantityOrdered))
                if (getValueCookie('CompanyId') === '6') {
                    // temporal[index].Comment = "BOX:" + getPriceMargin(temporal[index].UnitPrice, temporal[index].unitCost, this.state.SalesOrder.Customer.PriceLevel)
                    temporal[index].Comment = "BOX:" + this.state.SalesOrder.Customer.CustomerName
                    temporal[index].PureMargin = getPurePriceMargin(temporal[index].UnitPrice, temporal[index].unitCost)
                    
                }
                if (getValueCookie('CompanyId') === '6') {
                    if(this.checkMinPrice(temporal[index], e) && getValueCookie('TypeUser') !== '1') {
                        this.setState({ Products: temporal, ConfirmSave: 0 })
                        this.calculateTotals()
                    } else {
                    }
                } else {
                    this.setState({ Products: temporal, ConfirmSave: 0 })
                    this.calculateTotals()
                }
            }
        }
        await this.AutoSave()
        this.setState({ isInputFocused: false });
    }

    checkInputFocus = () => {
        this.setState({ isInputFocused: true });
    }

    clearSalesOrder() {
        const clear = {
            ConfirmSave: 0,
            confirmMargin: false,
            NotZeroUnitPrice: true,
            Customer: {
                AddressLine1: '',
                City: '',
                CustomerName: '',
                CustomerNo: '',
                EmailAddress: '',
                PriceLevel: undefined,
                SalespersonNo: '',
                State: '',
                TelephoneNo: '',
                ZipCode: '',
                uniqueTrack: '',
            },
            TotalLines: 0,
            NoOrder: '',
            Type: 'S',
            TotalQuantityOrdered: 0,
            TotalCost: 0,
            TotalWeight: 0,
            Date: getDateYearMonthDayDash(),
            Warehouse: '000',
            Packing: null,
            WeightOption: null,
            MAS90Status: 0,
            Duplicate: false,
        }
        this.setState({ SalesOrder: clear, Products: [], enableEdit: false })
        localStorage.removeItem('SalesOrderSave')
    }

    addComentary(item) {
        let comm = item.Comment
        Swal.fire({
            title: 'Product: ' + item.itemCode,
            html: `<div class='textAreaGeneral textAreaComment'>
                    <textarea id='comentOfSalesOrder' rows="10" cols="50">${comm}</textarea>
                   </div>
            `,
            backdrop: true,
            showCancelButton: true,
            confirmButtonText: 'Save Commentary',
            showLoaderOnConfirm: true,
            preConfirm: async () => {
                const temporal = this.state.Products
                const index = temporal.indexOf(item)
                if (index !== -1) {
                    const coment = Swal.getPopup().querySelector('#comentOfSalesOrder').value
                    temporal[index].Comment = coment
                    this.setState({ Products: temporal })
                }
            },
            allowOutsideClick: () => !Swal.isLoading()
        })
        this.AutoSave()
    }

    removeProduct(item) {
        let temporal = this.state.Products
        const index = temporal.indexOf(item)

        if (index !== -1) {
            temporal[index].quantityOrdered = 0
            temporal[index].totalCost = 0
            temporal[index].Visible = 0

            for (let a = 0; a < temporal.length; a++) {
                document.getElementById("quantityOrderedSalesOrder_" + a).value = temporal[a].quantityOrdered
                document.getElementById("unitPriceSalesOrder_" + a).value = temporal[a].UnitPrice
            }
            
            this.setState({ Products: temporal })
            this.calculateTotals()
        }
        this.AutoSave()
    }

    refreshInputs() {
        const temporal = this.state.Products
        for (let a = 0; a < temporal.length; a++) {
            document.getElementById("quantityOrderedSalesOrder_" + a).value = temporal[a].quantityOrdered
            document.getElementById("unitPriceSalesOrder_" + a).value = temporal[a].UnitPrice
        }
    }

    AsignLineSequence() {
        const head = this.state.SalesOrder
        if (getValueCookie('CompanyId') === '6') {
            const temporal = OrderArray(JSON.parse(JSON.stringify(this.state.Products)), 'IdCompany', true)

            let confirmMargin = false
            let NotZeroUnitPrice = true
            let count = 1
            let activeLines = 0
            for (const item of temporal) {
                item.LineSequence = count
                item.quantityShipped = 0
                count++
                if (!confirmMargin) {
                    confirmMargin = item.PureMargin > 20 ? false : true
                }
                if (item.UnitPrice <= 0 && item.Visible === 1) {
                    NotZeroUnitPrice = false
                }
                if (item.Visible !== 0) {
                    activeLines++
                }
            }

            head.TotalLines = activeLines
            this.setState({ confirmMargin: confirmMargin, NotZeroUnitPrice: NotZeroUnitPrice, SalesOrder: head })
            return temporal
        } else {
            const temporal = this.state.Products
            let NotZeroUnitPrice = true
            let count = 1
            let activeLines = 0
            for (const item of temporal) {
                item.LineSequence = count
                item.quantityShipped = 0
                count++
                if (item.UnitPrice <= 0 && item.Visible === 1) {
                    NotZeroUnitPrice = false
                }
                if (item.Visible !== 0) {
                    activeLines++
                }
            }
            head.TotalLines = activeLines
            this.setState({ NotZeroUnitPrice: NotZeroUnitPrice, SalesOrder: head })
            return temporal
        }
    }

    detailToPrint() {
        let items = []
        this.state.Products.forEach(element => {
            if (element.Visible === 1) {
                element.abbreviatedDesc = (element.completeDesc && element.completeDesc !== "null") ? element.completeDesc : element.abbreviatedDesc
                items.push(element)
            }
        });
        return items
    }

    // async updateMayalandSO(altitudeSO) {
    //     let mayalandTemporal = altitudeSO;
    //     mayalandTemporal.idCompany = "3"
    //     mayalandTemporal.company = 'Mayaland Atlanta'
    //     mayalandTemporal.Customer.CustomerNo = '0016027';
    //     mayalandTemporal.Detail = this.updateAltitudePrices(mayalandTemporal.Detail);
        
    //     // const result = await create_Delete_Update_Information('/sales/set/order', mayalandTemporal)
    //     await create_Delete_Update_Information('/sales/set/order', mayalandTemporal)
    // }

    async updateAltitudePrices(productList, priceLevel) {
        for (const element of productList) {
            const itemALT = await this.getAltItem(element, 6, priceLevel)
            const itemMY = await this.getAltItem(element, 3, priceLevel)
            // Calculate the price with LastTotalUnitCost (including the Altitude %5)
            let altitudePrice = itemALT[0].LastTotalUnitCost / (1 - (Number(itemALT[0].MarkUp) / 100)) ; //Sale Price
            // Validate if the N price is higher than the sale price
            if(itemMY[0].UnitPrice && itemMY[0].UnitPrice > altitudePrice) {
                altitudePrice = itemMY[0].UnitPrice
            }
            element.UnitPrice = Number(altitudePrice.toFixed(2))
        };
        return productList;
    }

    async getAltItem(item, idCompany, priceLevel = 1) {
        const data = {
            upc: item.itemCode,
            idCompany,
            priceLevel
        }
        const getAltItem = await getInformationWithData('/Items/getItemByUpc', data)
        return getAltItem.result
    }

    async checkSalesOrderStatus(SONumber){
        const data = {
            SalespersonNo: getValueCookie('SalesPerson'),
            idCompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId')),
        }
        const response = await getInformationWithData('/sales/get/header', data);
        const salesOrderList = response.data;

        const getSalesOrder = salesOrderList.find(obj => obj.SalesOrderNo === SONumber)
        if(getSalesOrder){
            return getSalesOrder.Status;
        }
        return 0
    }

    async createSalesOrder(LoadMas90) {
        await this.AsignLineSequence()
        Swal.fire({
            title: 'Are you sure to save this order?',
            text: "",
            icon: 'warning',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            showCancelButton: true,
            confirmButtonText: 'Yes, please',
            cancelButtonText: 'No, cancel!',
        }).then(async (result) => {
            if (result.isConfirmed) {
                const temporal = JSON.parse(JSON.stringify(this.state.SalesOrder))
                temporal.Detail = this.AsignLineSequence()
                temporal.idCompany = getValueCookie('CompanyId')
                temporal.username = getValueCookie('userName')
                temporal.company = getValueCookie('Company')
                temporal.OrderType = 'SalesOrder'
                temporal.MAS90Status = LoadMas90
                temporal.Packing = this.state.SalesOrder.Packing + ";" + this.state.SalesOrder.WeightOption

                await saveJsonData('/store/json', temporal)

                if (getValueCookie('CompanyId') !== '6' || (getValueCookie('CompanyId') === '6' && !this.state.confirmMargin)) {

                    if ((this.state.SalesOrder.Packing && this.state.SalesOrder.WeightOption) || getValueCookie('CompanyId') === '6') {
                        if (this.state.NotZeroUnitPrice) {
                            const result = await create_Delete_Update_Information('/sales/set/order', temporal)
                            if (result.status.code === 1) {
                                this.setState({ ConfirmSave: this.state.Products.length })
                                // enable next step wizard button
                                this.updateFormData(temporal)
                                await this.SaveAndPrint()
                                await confirmCloseAlert('correct', 'The order was saved successfully!')
                                localStorage.removeItem('SalesOrderSave')
                                // Update ALT SalesOrder
                                if (temporal.Customer.CustomerNo === '0016027'){
                                    // await this.updateCompanyPrices(temporal)
                                    // this.updateMayalandSO(temporal)
                                    await this.ModalLoading.current.showState(true);
                                    this.updateALTSO(temporal)
                                }
                                
                            } else {
                                confirmCloseAlert('incorrect', 'Whoops something is wrong with the system, please call system support.')
                            }
                        } else {
                            Swal.fire({
                                title: 'Some products have Unit Price on Zero.\nPlease Fix that!',
                                text: "",
                                icon: 'warning',
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                showCancelButton: true,
                                confirmButtonText: 'OK',
                                cancelButtonText: 'No, cancel!',
                            })
                        }
                    } else {
                        if (!this.state.SalesOrder.Packing) {
                            Swal.fire({
                                title: 'You need select a Type of Packing to Save this Sales Order!',
                                text: "",
                                icon: 'error',
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                showCancelButton: false,
                                confirmButtonText: 'Ok'
                            })
                        } else {
                            Swal.fire({
                                title: 'You need select if the order are Weighed or No need to be Weighed',
                                text: "",
                                icon: 'error',
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                showCancelButton: false,
                                confirmButtonText: 'Ok'
                            })
                        }
                    }
                } else {
                    Swal.fire({
                        title: 'Some products have Problem with the Unit Tracking.\nDo you like to continue?',
                        text: "",
                        icon: 'warning',
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        showCancelButton: true,
                        confirmButtonText: 'Yes, please',
                        cancelButtonText: 'No, cancel!',
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            if (this.state.NotZeroUnitPrice) {
                                const result = await create_Delete_Update_Information('/sales/set/order', temporal)
                                if (result.status.code === 1) {
                                    this.setState({ ConfirmSave: this.state.Products.length })
                                    await this.SaveAndPrint()
                                    await confirmCloseAlert('correct', 'The order was saved successfully!')
                                    localStorage.removeItem('SalesOrderSave')
                                    if (temporal.Customer.CustomerNo === '0016027'){
                                        // await this.updateCompanyPrices(temporal)
                                        // this.updateMayalandSO(temporal)
                                        await this.ModalLoading.current.showState(true);
                                        this.updateALTSO(temporal)
                                    }
                                } else {
                                    confirmCloseAlert('incorrect', 'Whoops something is wrong with the system, please call system support.')

                                }
                            } else {
                                Swal.fire({
                                    title: 'Some products have Unit Price on Zero.\nPlease Fix that!',
                                    text: "",
                                    icon: 'warning',
                                    confirmButtonColor: '#3085d6',
                                    cancelButtonColor: '#d33',
                                    showCancelButton: false,
                                    confirmButtonText: 'OK',
                                })
                            }
                        }
                    })
                }
            }
            if((this.state.SalesOrder.Packing && this.state.SalesOrder.WeightOption)){
                this.setState({enableEdit: true})
            }
            if (getValueCookie('CompanyId') === '6'){
                this.setState({enableEdit: true})
            }
        })
    }

    componentDidMount() {
        if (localStorage.getItem('SalesOrderSave')) {
            let infoRec = JSON.parse(localStorage.getItem('SalesOrderSave'));
            if (infoRec) {
                this.setState({ Products: infoRec.Products, SalesOrder: infoRec.SalesOrder })
            }
        }
        window.addEventListener('storage', this.handleStorageChange);
        if (getValueCookie('CompanyId') === '6') {
            this.getItemList();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('storage', this.handleStorageChange);
    }


    AutoSave() {
        localStorage.setItem('SalesOrderSave', JSON.stringify(this.state))
    }

    TypeInLetters(type) {
        if (type === 'S') {
            return 'Standard'
        } else {
            return 'Quote'
        }
    }

    handleModalOpen = (modal) => {
        this.setState({ [modal]: true })
    }

    handleModalClose = (modal) => {
        this.setState({ [modal]: false })
    }

    handleStorageChange = async (event) => {
        if (event.key === 'SalesOrderSave') {
            let infoRec = JSON.parse(localStorage.getItem('SalesOrderSave'));
            if (infoRec) {
                if (infoRec.SalesOrder.NoOrder === this.state.SalesOrder.NoOrder) {
                    await this.setState({ Products: infoRec.Products, SalesOrder: infoRec.SalesOrder })
                    await this.refreshInputs()
                }
            }
        }
    }

    validationNewSalesOrder() {
        if (this.state.Products.length !== this.state.ConfirmSave) {
            Swal.fire({
                title: 'Are you sure to Start a new Sales Order, you have a Sales Order open and unsave?',
                icon: 'info',
                showDenyButton: true,
                confirmButtonText: `Yes, I'm sure.`,
                denyButtonText: `Not`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.getNewCorrelativeSalesOrder()
                }
            })
        } else {
            this.getNewCorrelativeSalesOrder()
        }
        this.setState({isNotNewSO: false, newSalesOrder: true})
    }

    onChangeSelects = async (e, id) => {
        const temporal = this.state.SalesOrder
        switch (id) {
            case "Warehouse":
                temporal.Warehouse = e.value
                this.setState({ SalesOrder: temporal })
                this.changePriceLevel(e.value)
                break;
            case "Packing":
                temporal.Packing = e.value
                this.setState({ SalesOrder: temporal })
                break;
            case "Weight":
                temporal.WeightOption = e.value
                this.setState({ SalesOrder: temporal })
                break;
            default:
                break;
        }
    }

    changePriceLevel(id) {
        const temporal = this.state.SalesOrder
        switch (id) {
            case "003":
                temporal.Customer.PriceLevel = '4'
                this.setState({ SalesOrder: temporal })
                break;
            case "000":
                temporal.Customer.PriceLevel = '3'
                this.setState({ SalesOrder: temporal })
                break;

            default:
                break;
        }
    }

    // async OnlySaveSO() {
    //     const temporal = this.state.SalesOrder
    //     temporal.Detail = this.AsignLineSequence()
    //     temporal.idCompany = getValueCookie('CompanyId')
    //     temporal.username = getValueCookie('userName')
    //     temporal.company = getValueCookie('Company')
    //     temporal.OrderType = 'SalesOrder'
    //     await create_Delete_Update_Information('/sales/set/order', temporal)
    // }

    async TemporalSaveSystem() {
        const temporal = this.state.SalesOrder
        temporal.Detail = this.AsignLineSequence()
        temporal.idCompany = getValueCookie('CompanyId')
        temporal.username = getValueCookie('userName')
        temporal.company = getValueCookie('Company')
        temporal.OrderType = 'SalesOrder'
        if (temporal.idCompany === '6') {
            await create_Delete_Update_Information('/sales/post/savetemporal', temporal)
        }
    }

    async SaveAndPrint() {
        let button = document.getElementById('SalesOrderPrint')
        if (button) {
            button.click()
        }
    }

    disable() {
        this.setState({ disable: true })
    }

    toggleSelectSalesOrder(status) {
        this.setState({ disableSelectOrder: status })
    }

    async updateALTSO(SalesOrderData){
        // Get ALT SO
        const data = {
            OrderNo: SalesOrderData.NoOrder,
            SalesOrderNo: SalesOrderData.NoOrder,
            idCompany: 6,
            Module: ""
        }

        const getAltSO = await getInformationWithData('/sales/get/header/by-no', data)

        // Update ALT SO
        if(getAltSO.status.code === 1 && getAltSO.data.length > 0){
            let altitudeTemporal = SalesOrderData;
            
            altitudeTemporal.idCompany = "6"
            altitudeTemporal.company = 'Altitude Atlanta'
            altitudeTemporal.Customer.CustomerNo = getAltSO.data[0].CustomerNo;
            altitudeTemporal.Customer.CustomerName = getAltSO.data[0].BillToName;
            // Update Product List
            altitudeTemporal.Detail = await this.updateAltitudePrices(altitudeTemporal.Detail);
            const result = await create_Delete_Update_Information('/sales/set/order', altitudeTemporal)
            if(result.status.code !== 1){
                await confirmCloseAlert('Warning', 'It is possible this order was not changed in Altitude. Please after close this order verify the sales order in Altitude')
            }
        } else {
            Swal.fire({
                title: `This order is not found.\n It is possible ${SalesOrderData.NoOrder} was deleted`,
                text: "",
                icon: 'warning',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK',
            })
        }
        await this.ModalLoading.current.showState(false);
    }

    // Wizard functions start

    validateStep(step) {
        const { formData } = this.state
        if(step === 1) return formData.salesOrderNo
        if(step === 2) return formData.status
        return true
    }

    nextStep = () => {
        const { currentStep } = this.state
        // if(this.validateStep(currentStep)) {
            this.setState({currentStep: currentStep + 1})
        // }
        console.log("current step,", this.state.currentStep)
    }

    prevStep() {
        const { currentStep } = this.state
        this.setState({currentStep: currentStep - 1})
    }

    updateFormData(newData) {
        this.setState({
            formData: {...this.state.formData, ...newData}
        })
    }

    returnToFirstStep = () => {
        this.setState({currentStep: 1})
        this.clearSalesOrder()
        this.toggleSelectSalesOrder(false)
    }

    // Wizard functions end

    render() {
        const { currentStep } = this.state
        const hasOrder = this.state.SalesOrder.NoOrder !== ''
        const itemBadgeSPS = (val) => (
            <span style={{ background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE', borderRadius: '6px', padding: '2px 7px', fontSize: '0.72rem', fontWeight: 700 }}>{val}</span>
        )

        return (
            <div className="dash-page" style={{ paddingTop: '70px' }}>
                <Menu Refresh={this.state.Refresh} Father={this} />
                <LoadingWindow ref={this.ModalLoading} />

                {/* Hero */}
                <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #2563EB 100%)', padding: '1.25rem 2rem', display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
                    <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: '12px', padding: '0.75rem', display: 'flex' }}>
                        <BsBoxSeam style={{ color: 'white', fontSize: '1.75rem' }} />
                    </div>
                    <div style={{ flex: 1 }}>
                        <h1 style={{ color: 'white', fontWeight: 800, fontSize: '1.375rem', margin: 0 }}>Sales Order Picking</h1>
                        <p style={{ color: 'rgba(255,255,255,0.6)', margin: 0, fontSize: '0.8rem' }}>
                            {hasOrder
                                ? `Order: ${this.state.SalesOrder.NoOrder} · ${this.state.SalesOrder.Customer.CustomerName}`
                                : 'A new Sales Order cannot be started until the current one is finished'}
                        </p>
                    </div>
                </div>

                <div style={{ padding: '1.5rem 2rem' }}>

                {/* 1. Select sales order and open the order */}
                {currentStep === 1 && (
                    <div>
                        <div style={{ marginBottom: '1.25rem' }}>
                            <FinishedSalesOrderList disabled={this.state.disableSelectOrder} headerName='' nombrePadre="SalesOrderListSO" Padre={this} toggleSelectSalesOrder={this.toggleSelectSalesOrder.bind(this)} />
                        </div>

                        <div className="row g-3 mb-4">
                            {/* Order card */}
                            <div className="col-sm-12 col-md-6">
                                <div className="card h-100" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                                    <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem' }}>
                                        <span style={{ color: 'white', fontWeight: 700, fontSize: '0.875rem' }}>Order</span>
                                    </div>
                                    <div style={{ padding: '1.25rem', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '0.75rem' }}>
                                        <div className="pol-kv-box">
                                            <span>Order No</span>
                                            <strong>{this.state.SalesOrder.NoOrder || '—'}</strong>
                                        </div>
                                        <div className="pol-kv-box">
                                            <span>Person No</span>
                                            <strong>{this.state.SalesOrder.Customer.SalespersonNo || '—'}</strong>
                                        </div>
                                        <div className="pol-kv-box">
                                            <span>Price Level</span>
                                            <strong>{this.state.SalesOrder.Customer.PriceLevel !== undefined ? this.state.SalesOrder.Customer.PriceLevel : '—'}</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Customer card */}
                            <div className="col-sm-12 col-md-6">
                                <div className="card h-100" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                                    <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem' }}>
                                        <span style={{ color: 'white', fontWeight: 700, fontSize: '0.875rem' }}>Customer</span>
                                    </div>
                                    <div style={{ padding: '1.25rem', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '0.75rem' }}>
                                        <div className="pol-kv-box">
                                            <span>Customer No</span>
                                            <strong>{this.state.SalesOrder.Customer.CustomerNo || '—'}</strong>
                                        </div>
                                        <div className="pol-kv-box">
                                            <span>Name</span>
                                            <strong>{this.state.SalesOrder.Customer.CustomerName || '—'}</strong>
                                        </div>
                                        <div className="pol-kv-box">
                                            <span>Address</span>
                                            <strong>{this.state.SalesOrder.Customer.AddressLine1 || '—'}</strong>
                                        </div>
                                        <div className="pol-kv-box">
                                            <span>City</span>
                                            <strong>{this.state.SalesOrder.Customer.City || '—'}</strong>
                                        </div>
                                        <div className="pol-kv-box">
                                            <span>Zip Code</span>
                                            <strong>{this.state.SalesOrder.Customer.ZipCode || '—'}</strong>
                                        </div>
                                        <div className="pol-kv-box">
                                            <span>State</span>
                                            <strong>{this.state.SalesOrder.Customer.State || '—'}</strong>
                                        </div>
                                        <div className="pol-kv-box">
                                            <span>Telephone</span>
                                            <strong>{this.state.SalesOrder.Customer.TelephoneNo || '—'}</strong>
                                        </div>
                                        <div className="pol-kv-box">
                                            <span>Email</span>
                                            <strong>{this.state.SalesOrder.Customer.EmailAddress || '—'}</strong>
                                        </div>
                                        {getValueCookie('CompanyId') === '6' && (
                                            <div className="pol-kv-box">
                                                <span>Unique Tracking</span>
                                                <strong>{this.state.SalesOrder.Customer.uniqueTrack || '—'}</strong>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Search + Catalogue + Print */}
                        <div className="card mb-4" style={{ borderRadius: '12px', border: '1px solid #E2E8F0' }}>
                            <div className="card-body" style={{ padding: '1.25rem' }}>
                                <div className="row g-3 align-items-end">
                                    <div className="col-sm-6">
                                        <label style={{ fontSize: '0.78rem', color: '#64748B', fontWeight: 600, marginBottom: '0.3rem', display: 'block' }}>Search Product (UPC)</label>
                                        <SearchUPC ComponentName={'SalesOrder'} disabled={this.state.SalesOrder.NoOrder === '' || this.state.enableEdit} Padre={this} priceLevel={this.state.SalesOrder.Customer.PriceLevel} />
                                    </div>
                                    <div className="col-sm-6">
                                        <div id="sales-picking-actions" className='row g-2'>
                                            <div className='col-sm-6'>
                                                <Catalogue2 Customer={this.state.SalesOrder.Customer} id='Catalogue2' PriceLevel={this.state.SalesOrder.Customer.PriceLevel} Array={'Products'} nombrePadre={"SalesOrder"} colorButton='purpleButton' Padre={this} disabled={this.state.SalesOrder.NoOrder === '' || this.state.enableEdit} titleButton='Open Catalogue' needPrice={getValueCookie('SalesPerson') === '0010' ? false : true} needCost={getValueCookie('SalesPerson') === '0010' ? true : false} productList={'ProductList'} />
                                            </div>
                                            <div className='col-sm-6'>
                                                <div className="d-grid">
                                                    {MobileDisp() ?
                                                        <OrderPDF id={"SalesOrderPrint"} colorButton="blackButton" title="Sales Order Print"
                                                            companyLogo={getValueCookie('DocumentsLogo')}
                                                            OrderTitle="Sales Order"
                                                            contactInfo={this.state.companyPrintHeader}
                                                            OrderInfo1={["Order No:", this.state.SalesOrder.NoOrder, "Sales Person:", this.state.SalesOrder.Customer.SalespersonNo,
                                                                "Customer No:", this.state.SalesOrder.Customer.CustomerNo, "Date:", DateFormatMAS90(this.state.SalesOrder.Date),
                                                                "Customer Name:", this.state.SalesOrder.Customer.CustomerName, "Print By:", getValueCookie('userName'),
                                                                "Phone:", this.state.SalesOrder.Customer.TelephoneNo, "Printing Date:", FormatQueryReturnDateForReport(getActualDateUTC()),
                                                                "Address:", this.state.SalesOrder.Customer.AddressLine1, "Type:", this.TypeInLetters(this.state.SalesOrder.Type),
                                                                "City:", this.state.SalesOrder.Customer.City, "Zip Code:", this.state.SalesOrder.Customer.ZipCode,
                                                                "State:", this.state.SalesOrder.Customer.State, "", ""
                                                            ]}
                                                            headerTable={["Item Code", "", "Description", "", "Quantity \n Ordered", "", "Unit \n Price", "", "Total"]}
                                                            bodyTable={this.detailToPrint()}
                                                            headerBodyTable={["itemCode", "", "abbreviatedDesc", "", "quantityOrdered", "dolar", "UnitPrice", "dolar", "totalCost"]}
                                                            bottomInfo={["", "", "", "TOTALS", NumberFormat(this.state.SalesOrder.TotalQuantityOrdered), "", "", "$", NumberFormat(pricesFormat(this.state.SalesOrder.TotalCost))]}
                                                            styleColumns={["ColumnaTextoNormalLeft", "ColumnaTextoNormalLeft", "ColumnaTextoLargo2", "ColumnaTextoNormalLeft", "ColumnaCantidades", "Dolar", "ColumnaPrecios", "Dolar", "ColumnaPrecios"]}
                                                            comment={""}
                                                            breakpoint={52}
                                                            keysDecimalFormat={["UnitPrice", "totalCost"]}
                                                            disabled={this.state.enableEdit}
                                                        />
                                                        :
                                                        <DownloadOrderPDF id={"SalesOrderPrint"} colorButton="blackButton" title="Sales Order Print"
                                                            companyLogo={getValueCookie('DocumentsLogo')}
                                                            OrderTitle="Sales Order"
                                                            contactInfo={this.state.companyPrintHeader}
                                                            OrderInfo1={["Order No:", this.state.SalesOrder.NoOrder, "Sales Person:", this.state.SalesOrder.Customer.SalespersonNo,
                                                                "Customer No:", this.state.SalesOrder.Customer.CustomerNo, "Date:", DateFormatMAS90(this.state.SalesOrder.Date),
                                                                "Customer Name:", this.state.SalesOrder.Customer.CustomerName, "Print By:", getValueCookie('userName'),
                                                                "Phone:", this.state.SalesOrder.Customer.TelephoneNo, "Printing Date:", FormatQueryReturnDateForReport(getActualDateUTC()),
                                                                "Address:", this.state.SalesOrder.Customer.AddressLine1, "Type:", this.TypeInLetters(this.state.SalesOrder.Type),
                                                                "City:", this.state.SalesOrder.Customer.City, "Zip Code:", this.state.SalesOrder.Customer.ZipCode,
                                                                "State:", this.state.SalesOrder.Customer.State, "", ""
                                                            ]}
                                                            docname={this.state.SalesOrder.NoOrder}
                                                            headerTable={["Item Code", "", "Description", "", "Quantity \n Ordered", "", "Unit \n Price", "", "Total"]}
                                                            bodyTable={this.detailToPrint()}
                                                            headerBodyTable={["itemCode", "", "abbreviatedDesc", "", "quantityOrdered", "dolar", "UnitPrice", "dolar", "totalCost"]}
                                                            bottomInfo={["", "", "", "TOTALS", NumberFormat(this.state.SalesOrder.TotalQuantityOrdered), "", "", "$", NumberFormat(pricesFormat(this.state.SalesOrder.TotalCost))]}
                                                            styleColumns={["ColumnaTextoNormalLeft", "ColumnaTextoNormalLeft", "ColumnaTextoLargo2", "ColumnaTextoNormalLeft", "ColumnaCantidades", "Dolar", "ColumnaPrecios", "Dolar", "ColumnaPrecios"]}
                                                            comment={""}
                                                            breakpoint={52}
                                                            keysDecimalFormat={["UnitPrice", "totalCost"]}
                                                            disabled={this.state.enableEdit}
                                                        />
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Products table */}
                        <div className="card mb-4" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                            <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem' }}>
                                <span style={{ color: 'white', fontWeight: 700, fontSize: '0.875rem' }}>Products</span>
                            </div>
                            <div className="tableFixHeadSmall">
                                <table className="table table-clean mb-0">
                                    <thead>
                                        <tr className="text-center">
                                            <th>Item Code</th>
                                            <th className="text-start">Description</th>
                                            <th>Quantity</th>
                                            <th>Weight</th>
                                            <th>Total Weight</th>
                                            <th>Unit Price</th>
                                            <th className="text-end">Total</th>
                                            <th></th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.Products.map((item, i) => (
                                            <tr key={i} hidden={item.Visible === 0} className={item.duplicate ? item.duplicate : (item.UnitPrice <= 0 ? 'status-warning' : '')}>
                                                <td>{itemBadgeSPS(item.itemCode)}</td>
                                                <td className="text-start">{(item.completeDesc !== "null" && item.completeDesc) ? item.completeDesc : item.abbreviatedDesc}</td>
                                                <td>
                                                    <input disabled={this.state.enableEdit} type="number" id={'quantityOrderedSalesOrder_' + i} min={0} defaultValue={item.quantityOrdered} onChange={(e) => this.onTarget(e, item)}
                                                        className="form-control text-center" style={{ borderRadius: '8px', border: '1.5px solid #E2E8F0', maxWidth: '90px', margin: '0 auto' }} />
                                                </td>
                                                <td className="text-center" style={{ fontSize: '0.8rem', color: '#64748B' }}>{NumberFormat(pricesFormat(item.ShipWeight)) + ' lbs'}</td>
                                                <td className="text-center" style={{ fontSize: '0.8rem', color: '#64748B' }}>{NumberFormat(pricesFormat(item.quantityOrdered * item.ShipWeight)) + ' lbs'}</td>
                                                <td>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'center' }}>
                                                        <span style={{ color: '#64748B', fontWeight: 600 }}>$</span>
                                                        <input disabled={this.state.enableEdit} id={'unitPriceSalesOrder_' + i} min={0} step="0.01" defaultValue={Number(item.UnitPrice).toFixed(2)} onChange={(e) => this.onTargetChange(e, item)} value={item.UnitPrice} onBlur={(e) => this.onTarget(e, item)} onFocus={this.checkInputFocus}
                                                            className="form-control text-end" style={{ borderRadius: '8px', border: '1.5px solid #E2E8F0', maxWidth: '100px' }} />
                                                    </div>
                                                </td>
                                                <td className="text-end" style={{ fontWeight: 700, color: '#059669' }}>$ {NumberFormat(Number(item.totalCost).toFixed(2))}</td>
                                                <td>
                                                    <button disabled={this.state.enableEdit} type="button" onClick={() => this.addComentary(item)}
                                                        style={{ background: '#F1F5F9', border: '1px solid #E2E8F0', borderRadius: '6px', color: '#475569', padding: '0.35rem 0.6rem', cursor: this.state.enableEdit ? 'not-allowed' : 'pointer' }}>
                                                        <AiOutlineComment />
                                                    </button>
                                                </td>
                                                <td>
                                                    <button disabled={this.state.enableEdit} type="button" onClick={() => this.removeProduct(item)}
                                                        style={{ background: 'rgba(239,68,68,0.08)', border: '1px solid #FECACA', borderRadius: '6px', color: '#DC2626', padding: '0.35rem 0.6rem', cursor: this.state.enableEdit ? 'not-allowed' : 'pointer' }}>
                                                        <FiTrash />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot className="tfoot">
                                        <tr>
                                            <td></td>
                                            <td style={{ fontWeight: 700 }}>Totals</td>
                                            <td className="text-center" style={{ fontWeight: 700 }}>{NumberFormat(this.state.SalesOrder.TotalQuantityOrdered)}</td>
                                            <td></td>
                                            <td className="text-center" style={{ fontWeight: 700 }}>{NumberFormat(pricesFormat(this.state.SalesOrder.TotalWeight) + ' lbs')}</td>
                                            <td className="text-end" style={{ fontWeight: 700 }}>$</td>
                                            <td className="text-end" style={{ fontWeight: 700 }}>{NumberFormat(pricesFormat(this.state.SalesOrder.TotalCost))}</td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>

                        {/* End buttons */}
                        <div className="row g-3 justify-content-center mb-4">
                            <div className="col-sm-12 col-md-6">
                                <button hidden={this.state.enableEdit} disabled={this.state.Products.length === 0 || this.state.isInputFocused} type="button" onClick={() => this.createSalesOrder(1)}
                                    style={{ width: '100%', background: 'linear-gradient(135deg, #065F46, #059669)', border: 'none', borderRadius: '8px', color: 'white', fontWeight: 700, padding: '0.75rem', fontSize: '0.95rem', cursor: (this.state.Products.length === 0 || this.state.isInputFocused) ? 'not-allowed' : 'pointer', opacity: (this.state.Products.length === 0 || this.state.isInputFocused) ? 0.6 : 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.4rem' }}>
                                    <FiSave /> Save Order and Print
                                </button>
                            </div>
                            <div className="col-sm-12 col-md-6">
                                <button disabled={this.state.SalesOrder.NoOrder === ''} onClick={() => this.nextStep()}
                                    style={{ width: '100%', background: 'linear-gradient(135deg, #1e40af, #2563EB)', border: 'none', borderRadius: '8px', color: 'white', fontWeight: 700, padding: '0.75rem', fontSize: '0.95rem', cursor: this.state.SalesOrder.NoOrder === '' ? 'not-allowed' : 'pointer', opacity: this.state.SalesOrder.NoOrder === '' ? 0.6 : 1 }}>
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* 3. Pickup system and close the order*/}
                {currentStep === 2 && (
                    <SingleOrderPicking selectedOrder={this.state.SalesOrder} returnToFirstStep={this.returnToFirstStep} prevStep={this.prevStep} />
                )}
                </div>
            </div>
        )
    }
}